import { ICampaignLog } from "@/interfaces/campaign-logs.interface";
import { CampaignLogsMessages } from "@/messages/campaigns/logs/campaign-logs.messages";
import { IFilter } from "@/types/filter.types";

export const CAMPAIGN_LOGS_TABLE_COLUMNS = (messages: CampaignLogsMessages) => [
  messages.expandColumn, // "Coluna de expansão para os subgrid"
  messages.scheduleDate,
  messages.statusColumn, // "Status (Último status do envio)"
  messages.clientColumn, // "Cliente (Nome do Contato)"
  messages.phoneColumn, // "Celular (Número do WhatsApp)"
  messages.errorMessageColumn, // "Mensagem do Status (Mensagem em caso de erro)"
];

// Valores iniciais dos filtros
export const initialFilterValues: IFilter<ICampaignLog>[] = [];
